/**
 * Product extras: quote slider + sticky add-to-cart bar.
 * Loaded with `defer` only when the matching block/setting is active.
 */

if (!customElements.get('quote-slider')) {
  customElements.define(
    'quote-slider',
    class QuoteSlider extends HTMLElement {
      connectedCallback() {
        this.quotes = Array.from(this.querySelectorAll('.product__quote'));
        this.dots = Array.from(this.querySelectorAll('.product__quote-dot'));
        this.index = 0;
        this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;

        if (this.quotes.length < 2) return;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.show(parseInt(dot.dataset.index, 10));
            this.restart();
          });
        });

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (!reducedMotion.matches) this.start();

        // Pause rotation when the tab is hidden.
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else if (!reducedMotion.matches) this.start();
        });
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index) {
        this.index = index % this.quotes.length;
        this.quotes.forEach((quote, i) => quote.classList.toggle('is-active', i === this.index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
      }

      next() {
        this.show(this.index + 1);
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.next(), this.interval);
      }

      restart() {
        if (this.timer) this.start();
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }
  );
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.button = this.querySelector('.sticky-atc__button');
        if (!this.target) return;

        this.removeAttribute('hidden');

        this.button?.addEventListener('click', () => {
          // Proxy to the real add-to-cart button so cart behavior stays identical.
          if (this.target.disabled) {
            this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            this.target.click();
          }
        });

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle(
              'sticky-atc--visible',
              !entry.isIntersecting && entry.boundingClientRect.top < 0
            );
          },
          { threshold: 0 }
        );
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
